import { jsx as _jsx } from "react/jsx-runtime";
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()(theme => ({
    italic: {
        fontStyle: 'italic',
    },
    'fw-normal': {
        fontWeight: 'normal',
    },
    'fw-bold': {
        fontWeight: 'bold',
    },
    'fw-bolder': {
        fontWeight: 'bolder',
    },
    'fw-lighter': {
        fontWeight: 'lighter',
    },
    'fw-100': {
        fontWeight: 100,
    },
    'fw-200': {
        fontWeight: 200,
    },
    'fw-300': {
        fontWeight: 300,
    },
    'fw-400': {
        fontWeight: 400,
    },
    'fw-500': {
        fontWeight: 500,
    },
    'fw-600': {
        fontWeight: 600,
    },
    'fw-700': {
        fontWeight: 700,
    },
    'fw-800': {
        fontWeight: 800,
    },
    'fw-900': {
        fontWeight: 900,
    },
    'fw-inherit': {
        fontWeight: 'inherit',
    },
    'fw-initial': {
        fontWeight: 'initial',
    },
    'fw-unset': {
        fontWeight: 'unset',
    },
    'kind-muted': {
        color: theme.palette.grey[500],
    },
    'kind-price': {
        color: theme.palette.secondary.main,
    },
    'kind-inline': {
        display: 'contents',
    },
}));
const Text = ({ children, className, kind, fw, italic, ...props }) => {
    const { classes, cx } = useStyles();
    return (_jsx(Typography, { ...props, className: cx(className, {
            [classes[`fw-${fw}`]]: Boolean(fw),
            [classes[`kind-${kind}`]]: Boolean(kind),
            [classes.italic]: italic,
        }), children: children }));
};
export default Text;
